import React from 'react';
import { Card, CardHeader } from '@mui/material';

export const BaseCard = ({ children, ...rest }) => (
  <Card square elevation={24} {...rest}>
    {children}
  </Card>
);

export const BaseCardHeader = ({ title, ...rest }) => (
  <CardHeader
    {...rest}
    title={title}
    titleTypographyProps={{
      variant: 'subtitle1',
      color: 'text.secondary',
      sx: {
        lineHeight: 1.2,
      },
    }}
  />
);
